import { CSSProperties } from 'react';
import styled from 'styled-components';
import { useCarouselLayout } from '../../context';
import { ClearSelectionButton } from './clear-selection-button';

export function ActionBar() {
  const layout = useCarouselLayout();
  const area = layout.topTitlesArea();
  const rootStyle: CSSProperties = {
    position: 'absolute',
    top: area.y1,
    right: layout.fullArea().width - area.x2,
  };
  return (
    <Root style={rootStyle}>
      <Main>
        <ClearSelectionButton />
      </Main>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1em;
  z-index: 1;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
